import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#14213D]/10 py-6 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-[#14213D]/70 mx-8">{item}</span>
            <span className="text-[#D39A2E] text-xl">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
